import { createMutationHelper } from '@utils/swr'
import { type FastOrderCsvValidationArgs, type FastOrderMallRequest } from '../types/apiRequest'
import { type FastOrderCsvValidationResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<FortuneApis['post']['fastOrderCsvValidation'], FastOrderCsvValidationResponse, FastOrderCsvValidationArgs, FastOrderMallRequest>({
  client: 'fortune',
  key: params => params?.mall_code ? `/cross-brand-malls/${params.mall_code}/fast-order/csv-validation` : null,
  fetcher: (url, { arg, client }) => {
    const formData = new FormData()
    formData.append('file', arg.file)
    return client.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
})

export const useApiFastOrderCsvValidation = useMutation
